import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ReceivablesImportRow} from "../../../../shared/interface/receivables-import-row";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {ReceivablesImportsRowService} from "../../../../shared/services/receivables-imports-row.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {delay, takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {
  DictService,
  RECEIVABLES_IMPORT_ROW_STATUS,
  RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED,
  RECEIVABLES_IMPORT_ROW_STATUS_PAID_TO_TU,
  RECEIVABLES_IMPORT_ROW_STATUS_PAYMENT_REPORTED,
  RECEIVABLES_IMPORT_ROW_STATUS_TO_CANCELLED
} from "../../../../shared/services/dict.service";
import {FileBase64} from "../../../../shared/components/file-drag-and-drop/file-drag-and-drop.component";
import {Dictionary} from "../../../../shared/interface/dictionary";

export interface ChangeStatusDialogData {
  receivablesObject: ReceivablesImportRow;
}

@Component({
  selector: 'app-change-status-receivables-imports-row-dialog',
  templateUrl: './change-status-receivables-imports-row-dialog.component.html',
  styleUrls: ['./change-status-receivables-imports-row-dialog.component.scss']
})
export class ChangeStatusReceivablesImportsRowDialogComponent implements OnInit, OnDestroy  {

  readonly RECEIVABLES_IMPORT_ROW_STATUS_PAID_TO_TU = RECEIVABLES_IMPORT_ROW_STATUS_PAID_TO_TU;
  readonly RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED = RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED;
  readonly RECEIVABLES_IMPORT_ROW_STATUS_TO_CANCELLED = RECEIVABLES_IMPORT_ROW_STATUS_TO_CANCELLED;
  readonly RECEIVABLES_IMPORT_ROW_STATUS_PAYMENT_REPORTED = RECEIVABLES_IMPORT_ROW_STATUS_PAYMENT_REPORTED;

  changeStatusForm: FormGroup;
  receivablesObject: ReceivablesImportRow;
  processingRequest = false;
  statusControl: FormControl;
  statusKeyControl: FormControl;
  noteControl: FormControl;
  fileNameControl: FormControl;
  fileControl: FormControl;
  enableSaveButton = false;
  cancelled = null;
  fileContentControl: FormControl;
  fileMaxSize = 5242880;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<ChangeStatusReceivablesImportsRowDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeStatusDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private receivablesImportsRowService: ReceivablesImportsRowService,
    private snack: MatSnackBar,
    private dictService: DictService,
  ) {
    this.fileControl = new FormControl(false);
    this.receivablesObject = data.receivablesObject;
    this.statusKeyControl = fb.control('', [Validators.required ]);
    this.changeStatusForm = fb.group({
      status: this.statusControl = fb.control(''),
      note: this.noteControl = fb.control(''),
      fileContent: this.fileContentControl = fb.control('', [Validators.required]),
      fileName: this.fileNameControl = fb.control('')

    });
  }


  ngOnInit(): void {
    this.changeStatusForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.changeStatusForm.valid);

    this.statusKeyControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dictkey: string) => {
        this.dictService.get(dictkey, RECEIVABLES_IMPORT_ROW_STATUS)
          .subscribe((dict: Dictionary) => {
            this.statusControl.setValue(dict.id);
            if (RECEIVABLES_IMPORT_ROW_STATUS_TO_CANCELLED === dictkey) {
              this.fileControl.setValue(false);

              this.fileContentControl.reset();
              this.fileContentControl.disable();
              this.noteControl.enable();
              this.fileNameControl.reset();
              this.cancelled = true;
            } else
            {
              this.noteControl.reset();
              this.noteControl.disable();
              this.fileContentControl.enable();
              this.cancelled = false;
            }
          });
      });


    // this.statusControl.valueChanges
    //   .pipe(takeUntil(this.destroyed$))
    //   .subscribe((dictId: number) => {
    //     this.dictService.getKey(dictId)
    //       .subscribe((dictKey: string) => {
    //         if (RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED === dictKey) {
    //           this.fileControl.setValue(false);
    //
    //           this.fileContentControl.reset();
    //           this.fileContentControl.disable();
    //           this.noteControl.enable();
    //           this.fileNameControl.reset();
    //           this.cancelled = true;
    //         } else
    //         {
    //           this.noteControl.reset();
    //           this.noteControl.disable();
    //           this.fileContentControl.enable();
    //           this.cancelled = false;
    //         }
    //       });
    //   });


    this.fileControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((value: boolean) => {
        if (value) {
          this.fileContentControl.reset();
          this.fileContentControl.disable();
          this.noteControl.enable();
          this.fileNameControl.reset();
        }else
        {
          this.noteControl.reset();
          this.noteControl.disable();
          this.fileContentControl.enable();
        }

      });


  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  sendForm(): void {
    this.processingRequest = true;

    this.receivablesImportsRowService.cancelRow(this.receivablesObject.uuid,
      this.noteControl.value, this.statusControl.value,
      this.fileContentControl.value, this.fileNameControl.value
    )
      .subscribe(() => {
        this.snack.open('Pomyślnie zmieniono status', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji obiektu polisy wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }

  fileSelected($event: FileBase64): void {
    this.fileNameControl.setValue($event?.filename);
    this.fileContentControl.setValue($event?.base64);
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
